<template>
  <div>
    <div class="mobile_app_container">
      <div class="logo"></div>
      <h2>{{ str.title }}</h2>
      <div class="content">
        <p>{{ str.description }}</p>
      </div>
      <div class="icons">
        <v-icon class="notranslate">computer</v-icon>
        <v-icon class="notranslate">desktop_windows</v-icon>
      </div>
      <div class="tablet_info">
        <v-icon class="tablet_icon notranslate">screen_rotation</v-icon>
        <p>{{ str.tablet_info }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import strings from '../strings/MobileApp'
import VIcon from 'vuetify/es5/components/VIcon/VIcon'
export default {
  name: 'MobileApp',
  components: {
    VIcon
  },
  computed: {
    str: function () {
      const lang = this.$store.state.user.language ? this.$store.state.user.language : 'en'
      return Object.keys(strings).reduce((acc, key) => {
        return {
          ...acc,
          [key]: strings[key][lang]
        }
      }, {})
    }
  }
}
</script>

<style lang="scss" scoped>
  .mobile_app_container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 18px;
    max-width: 420px;
    margin: 0 auto;
    height: 100vh;
    min-height: 568px;
    text-align: center;
    font-family: Roboto, sans-serif;
    .logo {
      width: 148px;
      height: 148px;
      margin: 0 auto 24px;
      background: url("../assets/ip-logo.png") center center no-repeat;
      background-size: contain;
    }
    p {
      margin: 0;
    }
    .icons {
      margin-top: 24px;
      .v-icon {
        padding: 0 12px;
        color: rgba(0,0,0,0.38);
        font-size: 60px;
      }
    }
    .tablet_info {
      max-width: 316px;
      margin: 24px auto;
      display: flex;
      padding: 12px;
      border-radius: 8px;
      background: #f5f5f5;
      .tablet_icon {
        color: rgba(0,0,0,0.38);
        font-size: 36px;
      }
      p {
        margin-left: 12px;
        font-size: 15px;
        line-height: 18px;
        color: rgba(0,0,0,0.54);
        flex: 1;
        text-align: justify;
      }
    }
  }
</style>
